import { useState, useEffect } from 'react';
import {
  Layout,
  Avatar,
  Typography,
  Drawer,
  Button,
  Grid,
  Tooltip,
} from 'antd';
import MenuApp from './Menu';
import Logo from '../../images/logo_corpoeducacion-01.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faUser } from '@fortawesome/free-solid-svg-icons';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { getLocalStorage, LogOut } from '../../utils/helpers/helpers';

import './style.scss';
import { CustomButton } from '../../components';

const { Sider } = Layout;
const { Title } = Typography;
const { useBreakpoint } = Grid;

const SiderApp = () => {
  const screens = useBreakpoint();
  const [open, setOpen] = useState(null);

  useEffect(() => {
    setOpen(screens.lg); // true if ≥ 992px, false otherwise
  }, [screens]);

  if (open === null) {
    return null;
  }

  // Responsive Menu
  if (!screens.lg) {
    return (
      <div style={{ paddingTop: '1rem', position: 'fixed' }}>
        <Tooltip
          title={open ? 'Ocultar menú' : 'Mostrar menú'}
          placement="bottomRight"
        >
          <Button
            type="primary"
            icon={open ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />}
            onClick={() => setOpen(true)}
          />
        </Tooltip>
        <Drawer
          title={
            <>
              <div className="side-logo">
                <img src={Logo} alt="logo" />
              </div>
              <div className="side-title-container">
                <Title level={5}>
                  SIGA - Sistema de Gestión Administrativa y Contratación
                </Title>
                <Tooltip
                  title={open ? 'Ocultar menú' : 'Mostrar menú'}
                  placement="bottomRight"
                >
                  <Button
                    type="primary"
                    icon={open ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />}
                    onClick={() => setOpen(false)}
                  />
                </Tooltip>
              </div>
            </>
          }
          className="site-layout-background"
          placement="left"
          onClick={() => setOpen(false)}
          onClose={() => setOpen(false)}
          open={open}
          closeIcon={false}
        >
          <MenuApp />
          <div className="side-footer">
            <Avatar
              className="side-user-icon"
              icon={<FontAwesomeIcon icon={faUser} />}
            />
            <div className="side-user-info">
              <div className="side-user-name">
                USUARIO: {getLocalStorage('username')}
              </div>
              <div className="side-user-name">
                ROL: {getLocalStorage('role')}
              </div>
            </div>
            <Tooltip title="Cerrar sesión" placement="topRight">
              <CustomButton
                className="side-user-action"
                onClick={() => {
                  LogOut();
                }}
                type="ghost"
                text={
                  <>
                    <FontAwesomeIcon
                      icon={faSignOutAlt}
                      className="side-user-action-icon"
                    />
                  </>
                }
              />
            </Tooltip>
          </div>
        </Drawer>
      </div>
    );
  }

  // Normal Menu
  return (
    <Sider
      width={'19em'}
      breakpoint="lg"
      className="site-layout-background"
      collapsed={!open}
      collapsedWidth={70}
    >
      {open ? (
        <>
          <div className="side-logo">
            <img src={Logo} alt="logo" />
          </div>
          <div className="side-title-container">
            <Title level={5}>
              SIGA - Sistema de Gestión Administrativa y Contratación
            </Title>
            <Tooltip
              title={open ? 'Ocultar menú' : 'Mostrar menú'}
              placement="bottomRight"
            >
              <Button
                type="primary"
                icon={open ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />}
                onClick={() => setOpen(false)}
              />
            </Tooltip>
          </div>
        </>
      ) : (
        <div className="side-title-container">
          <Tooltip
            title={open ? 'Ocultar menú' : 'Mostrar menú'}
            placement="bottomRight"
          >
            <Button
              type="primary"
              icon={open ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />}
              onClick={() => setOpen(true)}
            />
          </Tooltip>
        </div>
      )}
      <MenuApp collapsed={!open} />
      {open && (
        <div className="side-footer">
          <Avatar
            className="side-user-icon"
            icon={<FontAwesomeIcon icon={faUser} />}
          />
          <div className="side-user-info">
            <div className="side-user-name">
              USUARIO: {getLocalStorage('username')}
            </div>
            <div className="side-user-name">ROL: {getLocalStorage('role')}</div>
          </div>
          <Tooltip title="Cerrar sesión" placement="topRight">
            <CustomButton
              className="side-user-action"
              onClick={() => {
                LogOut();
              }}
              type="ghost"
              text={
                <>
                  <FontAwesomeIcon
                    icon={faSignOutAlt}
                    className="side-user-action-icon"
                  />
                </>
              }
            />
          </Tooltip>
        </div>
      )}
    </Sider>
  );
};
export default SiderApp;
